import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "アフリカ向けアプリを開発いたしました。このアプリは、デジタルを活用したユーザー接点の展開のためのものです。弊社はデジタルトランスフォーメーションを推進するため、ワークショップの開催からサービス開発までを支援を実施しました。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const mirronPageMeta: PageMeta = {
  title: "mirron | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "UIUX モバイルアプリ システム化 DX推進 フロントエンド開発",
  image: primaryImage,
  url: `${SITE_URL}/cases/mirron/`,
}

export const mirronSchema = buildCaseStudySchema({
  slug: "mirron",
  pageTitle: mirronPageMeta.title,
  description: mirronPageMeta.description,
  headline: "mirron",
  alternativeHeadline: "大手化学メーカー",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/mirron.webp"],
  clientName: "大手化学メーカー",
  breadcrumbLabel: "mirron",
})
